import { useQuery } from "@tanstack/react-query";
import { getUserProfile } from "../services/infractions.service";
import { infractionQueryKeys } from "./infraction-query-keys";

export function useUserProfile() {
	return useQuery({
		queryKey: infractionQueryKeys.userProfile(),
		queryFn: getUserProfile,
	});
}
